import { Component, OnInit } from "@angular/core";
import { AlertsService } from "./alerts.service";
import { AlertTranslation } from "../shared/translation.service";

@Component({
  selector: "create-alert",
  template: require('./createalert.component.html'),
  styles: [require('./createalert.component.scss')]
})
export class CreateAlertComponent implements OnInit {
  alert: any = {
    active: false,
    context: {
      project_ids: [],
      nationalities: [],
      employer_ids: [],
      countries: []
    },
    content: {}
  };
  translations: any[] = [];
  languages: any[] = this.service.getLanguages();
  alertTypes: any[] = this.service.getAlertTypes();
  sent: boolean = false;
  activePanels: string[] = ["visibility"];
  submitted: boolean = false;

  constructor(private service: AlertsService) {}

  ngOnInit() {
    this.addTranslation();
    this.translations[0].language = "en";
    this.alert.type = this.alertTypes[0].key;
  }

  addTranslation() {
    this.translations.push(new AlertTranslation());
    this.activePanels.push("translations" + (this.translations.length - 1));
  }

  deleteTranslation(item: any) {
    let index = this.translations.indexOf(item);
    if (index > -1) {
      this.translations.splice(index, 1);
      this.activePanels.splice(this.activePanels.length - 1, 1);
    }
  }

  getPanelTitle(translation: AlertTranslation, first: boolean) {
    let text;
    let selectedLang = this.languages.filter((language: any) => {
      return language.key === translation.language;
    })[0];
    text =
      selectedLang && selectedLang.value
        ? selectedLang.value
        : "Choose a language";
    if (first) {
      text += " (Default)";
    }
    return text;
  }

  setDefault(index: number) {
    let t = this.translations[0];
    this.translations[0] = this.translations[index];
    this.translations[index] = t;
  }

  back() {
    window.history.back();
  }

  onSubmit() {
    this.activePanels = [];
    setTimeout(() => {
      this.save();
    }, 1);
  }

  save() {
    if (!this.sent) {
      this.sent = true;
      let defLang;
      this.translations.map((it: any) => {
        if (it.language !== "") {
          if (!defLang) {
            defLang = it.language;
          }
          this.alert.content[it.language] = {
            title: it.title,
            description: it.description
          };
        }
      });
      this.alert.default_lang = defLang;
      this.service.createAlert(this.alert).subscribe(
        (response) => {
          this.sent = false;
          this.back();
        },
        (error) => {
          this.activePanels = ["visibility"];
          this.translations.map((it, index) => {
            this.activePanels.push("translations" + index);
          });
          this.sent = false;
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/alerts/createalert.component.ts